// extracted by mini-css-extract-plugin
module.exports = {"iconModule":"antd-pro-pages-home-microsite-web-site-set-up-home-page-setting-components-phone-preview-components-color-module31-index-iconModule"};